import { useAtom } from 'jotai/index';
import { langAtom, languagesListAtom } from '../atoms/globalAtoms';
import { LANGUAGES } from '../constants/languages';
import LocalStorageServices from '../services/LocalStorageServices';

const useTranslations = () => {
  const [lang, setLang] = useAtom(langAtom);
  const [languagesList] = useAtom(languagesListAtom);

  function t(dictObj, ...params) {
    if (!dictObj[lang]) {
      return dictObj[LANGUAGES.ru.code]?.(...params);
    }
    return dictObj[lang](...params);
  }

  const changeLang = (code) => {
    /* if (!languagesList[code]) {
      code = LANGUAGES.ru.code;
    } */

    LocalStorageServices.setLang(code);
    setLang(code);
  };

  return {
    lang, setLang: changeLang, t,
  };
};

export default useTranslations;
